module.exports = __webpack_public_path__ + "static/media/Logo_exclusive_small.8194ec6f.png";